module.exports = __webpack_public_path__ + "img/visa.e682aeb1.svg";